import { PresentationTreeResponse } from 'app/api/tag-queries/types';
import { TaxonomyWrapper } from 'app/components/editor/sidebar/tags/taxonomy/TaxonomyWrapper';
import { i18n } from 'app/utils/i18n';

interface PresentationTreePaneProps {
  data: PresentationTreeResponse | null | undefined;
  extensionTags?: string[];
  usedTags?: string[];
  selectedConceptName: string | null;
  selectedNodeKey: string | null;
  onSelect: (conceptName: string, nodeKey?: string) => void;
}

export const PresentationTreePane = ({ data, extensionTags, usedTags, selectedConceptName, selectedNodeKey, onSelect }: PresentationTreePaneProps) => {
  const networks = data?.presentationTree?.networks ?? [];

  if (networks.length === 0) {
    return <div className="tree-overview__pane-empty">{i18n('tag.treeOverview.empty.presentation')}</div>;
  }

  return (
    <>
      {networks.map((network, idx) => (
        <TaxonomyWrapper
          key={`${network.linkrole.roleURI}|${idx}`}
          {...network}
          selectedTagId={selectedConceptName}
          selectedNodePath={selectedNodeKey}
          expandToIds={null}
          usedTags={usedTags ?? []}
          extensionTags={extensionTags ?? []}
          onSelectTag={(tag, nodePath) => onSelect(tag.id, nodePath)}
        />
      ))}
    </>
  );
};
